import { UrlConstants } from "../url.constants";
export class ApiStepManagementConstants {
    static URL = UrlConstants.API_V2 + "StepManagement";
    static FUNCTION_SET_STEP_ASSIGNMENT = "SetStepAssignment";
}
